import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import PicMaterialTable from './PicMaterialTable';
import PicProductTable from './PicProductTable';

interface PicTableProps {
  currentSelectNode: any;
  pageType: string;
}

const PicTable: ForwardRefExoticComponent<PropsWithoutRef<PicTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
  },
  ref,
) => {
  return (
    <>
      {currentSelectNode?.isMaterial ? (
        <PicMaterialTable
          currentSelectNode={currentSelectNode}
          pageType={pageType}
        />
      ) : (
        <PicProductTable
          currentSelectNode={currentSelectNode}
          pageType={pageType}
        />
      )}
    </>
  );
});

export default PicTable;
